<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de Empresas"
          icon="fas fa-coins"
          btn_name="Empresa"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          @mtd_deploy="mtd_deploy"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'20%'"
          :buttonEdit="true"
          :buttonDelete="true"
          :myButtons="myButtons"
          @mtd_roles="mtd_roles"
          @mtdInstance="mtdInstance"
        />
      </CCol>
    </CRow>

    <!-- modal -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="12">
          <!-- <cSelectForm label="Tipo de empresa" placeholder="Seleccione tipo de empresa" :options="data_type_company"
            :value.sync="companies.type_company" :disabled="this.$store.getters.get_all_user.id !== 1" /> -->
          <CInput
            label="Fecha de culminación"
            type="date"
            v-model="companies.completion_date"
          />
          <CInput
            label="Razón social"
            placeholder="Digite Razón social"
            v-model="companies.name"
          />
          <CInput
            label="RUC"
            placeholder="Digite RUC"
            v-model="companies.ruc"
            maxlength="11"
            @input="validateRUC"
          />
          <span v-if="errors.ruc" class="text-danger">{{ errors.ruc }}</span>
          <CInput
            label="Telefono"
            placeholder="Digite Telefono"
            v-model="companies.phone"
            maxlength="9"
            @input="validatePhone"
          />
          <span v-if="errors.phone" class="text-danger">{{
            errors.phone
          }}</span>
          <CInput
            label="Correo"
            placeholder="Digite Correo"
            v-model="companies.email"
            @input="validateEmail(companies.email)"
            type="email"
          />
          <span v-if="errors.email_company" class="text-danger">{{
            errors.email_company
          }}</span>
          <div class="mb-2">¿Desea apertura y cierre de caja?</div>
          <CSwitchVue
            @changeSwitch="handleSwitchChange"
            v-model="companies.box"
            color="success"
            variant="opposite"
            shape="pill"
            class=""
            :checked="companies.box == 1"
            v-bind="labelIcon"
          />
          <div class="mb-2">¿Realiza devolucion de dinero?</div>
          <CSwitchVue
            @changeSwitch="handleSwitchChangeDevolution"
            v-model="companies.devolution"
            color="success"
            variant="opposite"
            shape="pill"
            class=""
            :checked="companies.devolution == 1"
            v-bind="labelIcon"
          />
          <div class="mb-2">Logo</div>
          <input
            @change="getFile"
            type="file"
            class="form-control"
            id="file"
            lang="es"
            name="file"
            ref="fileInput"
            accept=".png,.jpg,.jpeg"
          />
          <div
            v-if="companies.logo && modal.action !== 'store'"
            class="container-img"
          >
            <img
              v-if="typeof companies.logo === 'string' && companies.logo"
              :src="'https://mybarber.howertpi.com/assets/' + companies.logo"
              class="img-thumbnail"
              style="max-width: 100px"
              alt="Company Logo"
            />
            <p v-else></p>
          </div>
        </CCol>
        <CCol sm="12">
          <label
            v-if="modal.action === 'store'"
            class="mt-3 mb-2 font-lg font-weight-bold"
            >Datos del Representante</label
          >
          <CInput
            v-if="modal.action === 'store'"
            label="Nombre"
            placeholder="Digite nombre del representante"
            v-model="users.name"
            @input="ValidateName"
          />
          <span v-if="errors.name" class="text-danger">{{ errors.name }}</span>

          <CInput
            v-if="modal.action === 'store'"
            label="Apellido"
            placeholder="Digite apellido del representante"
            v-model="users.last_name"
            @input="ValidateLastName"
          />
          <span v-if="errors.last_name" class="text-danger">{{
            errors.last_name
          }}</span>

          <CSelect
            v-if="modal.action === 'store'"
            label="Tipo de documento"
            :value.sync="users.document_type"
            :options="type_documents"
            placeholder="--Seleccione un documento--"
            @change="onDocumentTypeChange"
          />

          <CInput
            v-if="modal.action === 'store'"
            label="Número de documento"
            placeholder="Digite número de documento"
            v-model="users.dni"
            :maxlength="documentMaxLength"
            :disabled="!users.document_type"
            @input="validateDocument"
          />
          <span
            v-if="modal.action === 'store' && errors.dni"
            class="text-danger"
            >{{ errors.dni }}</span
          >

          <CInput
            v-if="modal.action === 'store'"
            label="Telefono"
            placeholder="Digite Telefono"
            v-model="users.phone"
            @input="validatePhoneEmployee"
            maxlength="9"
          />
          <span
            v-if="modal.action === 'store' && errors.phone_barber"
            class="text-danger"
            >{{ errors.phone_barber }}</span
          >

          <CInput
            v-if="modal.action === 'store'"
            label="Correo"
            placeholder="Digite Correo"
            type="email"
            @input="validateEmail(users.email)"
            v-model="users.email"
          />
          <span
            v-if="modal.action === 'store' && errors.email_barber"
            class="text-danger"
            >{{ errors.email_barber }}</span
          >
        </CCol>

        <CCol sm="12">
          <CInput
            label="Precio por boleta"
            placeholder="00.00"
            min="0"
            step="1"
            type="number"
            v-model="companies.unit_price"
            :disabled="isMonthlyPriceSet"
            @change="handleUnitPriceChange"
          />
        </CCol>

        <CCol sm="12">
          <CInput
            label="Precio mensual de boletas"
            placeholder="00.00"
            min="0"
            step="1"
            type="number"
            v-model="companies.monthly_price"
            :disabled="isUnitPriceSet"
            @change="handleMonthlyPriceChange"
          />
        </CCol>

        <CCol sm="12">
          <CInput
            label="Precio Proveedor"
            placeholder="00.00"
            min="0"
            step="1"
            type="number"
            v-model="companies.provider_price"
          />
        </CCol>

        <CCol
          v-if="modal.action != 'store'"
          sm="12"
          lg="12"
          xl="12"
          xxl="12"
          xs="12"
          class="pt-2"
        >
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="companies.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Empresa'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />

    <cModalAddRolesVue
      @mtd_closeAddRoles="mtd_closeAddRoles"
      :boo_modal="modalAddRoles.modal_form"
      :title="modalAddRoles.title"
      :id_company="modalAddRoles.id_company"
      :item="modalAddRoles.item"
    />

    <cModalWsp
      @mtdCloseModalWsp="mtdCloseModalWsp"
      :boo_modal="modalWsp.modal_form"
      :title="modalWsp.title"
      :id_company="modalWsp.id_company"
      :item="modalWsp.item"
    />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "name", label: "Razón Social", _style: "width:10%;" },
  { key: "ruc", label: "RUC", _style: "width:10%;" },
  { key: "phone", label: "Teléfono", _style: "width:10%;" },
  // { key: "email", label: "Correo", _style: "width:10%;" },
  {
    key: "completion_date",
    label: "Fecha de culminación",
    _style: "width:20%;",
  },
  { key: "environment", label: "Facturación", _style: "width:10%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../../components/shared/datatable/Table.vue";
import CModalForm from "../../../components/shared/modals/cModalForm.vue";
import cModalDelete from "../../../components/shared/modals/cModalDelete.vue";
import cModalAddRolesVue from "./modals/cModalAddRoles.vue";
import { mapActions } from "vuex";
import CSwitchVue from "../../shared/switch/CSwitch.vue";
import moment from "moment";
import cModalWsp from './modals/cModalWsp.vue';

export default {
  components: {
    CTableWrapper,
    CModalForm,
    cModalDelete,
    CSwitchVue,
    cModalAddRolesVue,
    cModalWsp
  },
  data() {
    return {
      prefix: "companies",
      fields,
      type_documents: ["DNI", "PASAPORTE", "CARNET EXTRANJERÍA", "RUC"],
      data: [],
      myButtons: [
        {
          class: "btn-sm",
          color: "dark",
          tooltip: "Agregar Roles",
          action: "mtd_roles",
          icon: "fas fa-solid fa-user",
        },
        {
          class: "btn-sm",
          color: "warning",
          tooltip: "pasar a modo deploy",
          action: "mtd_deploy",
          icon: "fas fa-solid fa-rocket",
        },
        {
          class: "btn-sm",
          color: "success",
          tooltip: "Instancia de wsp",
          action: "mtdInstance",
          icon: "fab fa-whatsapp",
        },
      ],
      modalAddRoles: {
        title: "",
        modal_form: false,
        item: {},
        id_company: 0,
      },
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      data_type_company: [
        { value: 1, label: "BARBERIA" },
        { value: 2, label: "VETERINARIA" },
      ],
      companies: {
        id: "",
        name: "",
        completion_date: "",
        ruc: "",
        phone: "",
        email: "",
        logo: "",
        state: 0,
        box: 0,
        devolution: 0,
        unit_price: 0,
        monthly_price: 0,
        provider_price: 0,
      },
      users: {
        id: "",
        name: "",
        last_name: "",
        document_type: "",
        dni: "",
        phone: "",
        email: "",
        state: 0,
      },
      errors: {
        ruc: "",
        phone: "",
        dni: "",
        phone_barber: "",
        email_company: "",
        email_barber: "",
        last_name: "",
        name: "",
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      documentMaxLength: 8,
      modalWsp: {
        title: "",
        modal_form: false,
        item: {
          id:0,
          instance_name:"",
          instance_id:"",
          conected:"",
          state:""
        },
      },
    };
  },
  computed: {
    isUnitPriceSet() {
      return this.companies.unit_price > 0;
    },

    isMonthlyPriceSet() {
      return this.companies.monthly_price > 0;
    },

    cpStatus: function () {
      if (this.companies.state == 1) return true;
      return false;
    },
    cp_button: function () {
      if (this.modal.action == "store") {
        if (
          this.companies.name !== "" &&
          this.companies.ruc !== "" &&
          this.companies.phone !== "" &&
          this.companies.email !== "" &&
          (this.companies.unit_price > 0 || this.companies.monthly_price > 0) &&
          this.companies.provider_price !== "" &&
          this.users.name !== "" &&
          this.users.last_name !== "" &&
          this.users.dni !== "" &&
          this.users.email !== "" &&
          this.errors.email_company == "" &&
          this.errors.email_barber == "" &&
          this.errors.name == "" &&
          this.errors.last_name == ""
        )
          return false;
        return true;
      }
      if (this.modal.action == "update") {
        if (
          this.companies.name !== "" &&
          this.companies.ruc !== "" &&
          this.companies.phone !== "" &&
          this.companies.email !== "" &&
          this.errors.email_company == "" &&
          (this.companies.unit_price > 0 || this.companies.monthly_price > 0) &&
          this.companies.provider_price !== ""
        )
          return false;
        return true;
      }
    },
  },
  watch: {
    "companies.unit_price": {
      handler(newValue) {
        if (newValue === "" || newValue < 0) {
          this.companies.unit_price = 0;
        }
      },
    },
    "companies.monthly_price": {
      handler(newValue) {
        if (newValue === "" || newValue < 0) {
          this.companies.monthly_price = 0;
        }
      },
    },
  },
  created() {
    this.mtd_getdata();
  },
  methods: {
    ...mapActions(["get", "post"]),
    handleUnitPriceChange(value) {
      let numValue = parseFloat(value) || 0;
      if (numValue < 0) numValue = 0;
      this.companies.unit_price = numValue;
      if (numValue > 0) {
        this.companies.monthly_price = 0;
      }
    },
    handleMonthlyPriceChange(value) {
      let numValue = parseFloat(value) || 0;
      if (numValue < 0) numValue = 0;
      this.companies.monthly_price = numValue;
      if (numValue > 0) {
        this.companies.unit_price = 0;
      }
    },
    mtd_roles: function (item) {
      this.modalAddRoles = {
        title: "Agregar Roles",
        modal_form: true,
        id_company: item.Id,
        item: item,
      };
    },
    mtd_closeAddRoles: function () {
      this.modalAddRoles.modal_form = false;
    },
    handleSwitchChange(payload) {
      this.companies.box = payload ? 1 : 0;
    },
    handleSwitchChangeDevolution(payload) {
      this.companies.devolution = payload ? 1 : 0;
    },
    getFile(e) {
      let fileInput = this.$refs.fileInput;
      let file = e.target.files[0];
      if (
        !/\.(png)$/i.test(file.name) &&
        !/\.(jpg)$/i.test(file.name) &&
        !/\.(jpeg)$/i.test(file.name)
      ) {
        fileInput.value = "";
      } else {
        this.companies.logo = file;
      }
    },
    mtd_getdata: function () {
      this.get({
        url: this.$store.getters.get__url + "/companies/index",
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.data = response.data.data;
        let index = 1;
        this.data.forEach((arr) => {
          arr.index = index;
          index++;
        });
      });
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nueva Empresa")
        : (this.modal.title = "Editar Empresa");
      if (action == "store") {
        this.companies = {
          id: "",
          name: "",
          completion_date: "",
          ruc: "",
          phone: "",
          email: "",
          logo: "",
          // type_company: "",
          state: 0,
          box: 0,
          devolution: 0,
          unit_price: 0,
          monthly_price: 0,
          provider_price: 0,
        };
        this.users = {
          id: "",
          name: "",
          last_name: "",
          dni: "",
          phone: "",
          // address: "",
        };
        this.errors = {
          ruc: "",
          phone: "",
          dni: "",
          phone_barber: "",
          email_company: "",
          email_barber: "",
        };
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }
      } else {
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }
        this.companies = this.companies;
        this.users = this.users;
        this.errors = {
          ruc: "",
          phone: "",
          dni: "",
          phone_barber: "",
          email_company: "",
          email_barber: "",
        };
      }
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_deploy: function (item) {
      const stateEnvironment = item.environment;
      const newEnvironment =
        stateEnvironment === "local" ? "production" : "local";
      const actionText =
        stateEnvironment === "local"
          ? "cambiar a producción"
          : "cambiar a local";
      Swal.fire({
        title: "¿Estás seguro?",
        html: `¿Deseas ${actionText} las facturas para <strong>${item.name}</strong>?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        denyButtonColor: "#cfc83d",
        confirmButtonText: "Sí, sin reinicio",
        cancelButtonText: "Cancelar",
        showDenyButton: true,
        denyButtonText: "Sí, con reinicio",
      }).then((result) => {
        if (result.isConfirmed) {
          this.post({
            url:
              this.$store.getters.get__url +
              "/" +
              this.prefix +
              "/deploy/" +
              item.Id,
            token: this.$store.getters.get__token,
            params: {
              environment: newEnvironment,
              reset_correlatives: false,
            },
          }).then((response) => {
            if (response.statusCode == 200) {
              Swal.fire(
                "¡Completado!",
                `Las facturas han sido cambiadas a ${newEnvironment}`,
                "success"
              );
              this.mtd_getdata();
            }
          });
        } else if (result.isDenied) {
          this.post({
            url:
              this.$store.getters.get__url +
              "/" +
              this.prefix +
              "/deploy/" +
              item.Id,
            token: this.$store.getters.get__token,
            params: {
              environment: newEnvironment,
              reset_correlatives: true,
            },
          }).then((response) => {
            if (response.statusCode == 200) {
              Swal.fire(
                "¡Completado!",
                `Las facturas han sido cambiadas a ${newEnvironment} y se reiniciaron los correlativos`,
                "success"
              );
              this.mtd_getdata();
            }
          });
        }
      });
    },
    mtd_action: function () {
      if (!this.validateForm()) return;

      let formData = new FormData();
      // formData.append("company", this.$store.getters.get_company);
      formData.append("id", this.companies.id);
      formData.append("completion_date", this.companies.completion_date);
      formData.append("name", this.companies.name);
      formData.append("ruc", this.companies.ruc);
      formData.append("phone", this.companies.phone);
      formData.append("email", this.companies.email);
      formData.append("logo", this.companies.logo);
      formData.append("box", this.companies.box);
      formData.append("devolution", this.companies.devolution);
      formData.append("unit_price", this.companies.unit_price);
      formData.append("monthly_price", this.companies.monthly_price);
      formData.append("provider_price", this.companies.provider_price);

      // formData.append("type_company", this.companies.type_company);
      formData.append("state", this.companies.state);
      if (this.modal.action === "store") {
        formData.append("user_name", this.users.name);
        formData.append("completion_date", this.companies.completion_date);
        formData.append("user_last_name", this.users.last_name);
        formData.append("document_type", this.users.document_type);
        formData.append("user_dni", this.users.dni);
        formData.append("user_email", this.users.email);
        formData.append("user_phone", this.users.phone);
      }
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: formData,
      })
        .then((response) => {
          if (
            response.data.state == 1 ||
            response.data.state == 2 ||
            response.data.state == 3 ||
            response.data.state == 4
          ) {
            if (response.data.state == 1) {
              Swal.fire({
                title: "RUC ya resgistrado",
                icon: "warning",
              });
            } else if (response.data.state == 2) {
              Swal.fire({
                title: "DNI ya resgistrado",
                icon: "warning",
              });
            } else if (response.data.state == 3) {
              Swal.fire({
                title: "Email de la Compañia ya resgistrado",
                icon: "warning",
              });
            } else {
              Swal.fire({
                title: "Email del Representante ya resgistrado",
                icon: "warning",
              });
            }
          } else {
            let color = "success";
            let message = "";
            if (this.modal.action == "store") {
              message = "REGISTRADO CORRECTAMENTE";
              this.mtd_getdata();
            } else {
              let updatedCompany = response.data.data.company;
              let updatedEmployee = response.data.data.employee;
              let index = this.data.findIndex(
                (company) => company.id === updatedCompany.id
              );
              if (index !== -1) {
                this.$set(this.data, index, {
                  ...updatedCompany,
                  ...updatedEmployee,
                });
              }
              message = "EDITADO CORRECTAMENTE";
              this.mtd_getdata();
            }
            this.modal = {
              action: "",
              title: "",
              modal_form: false,
              name: "",
            };
            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.errors.ruc = "";
          this.errors.phone = "";
          this.errors.dni = "";
          this.errors.phone_barber = "";

          this.companies = response;
          if (this.companies.logo) {
            let url_logo = this.companies.logo;
            let url = this.$store.getters.get__url;
            let urlModifie = url.replace("api/v1", "");
            this.companies.logo = url_logo.replace(
              "http://localhost/",
              urlModifie
            );
          } else {
            this.companies.logo = "";
          }

          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      })
        .then((response) => {
          this.mtd_getdata();
          this.modal_delete = {
            boo: false,
            item: [],
          };

          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
        })
        .catch((errors) => {});
    },
    validateRUC() {
      if (this.companies.ruc.length != 11 || isNaN(this.companies.ruc)) {
        this.errors.ruc = "El RUC debe ser un número de máximo 11 dígitos";
      } else {
        this.errors.ruc = "";
      }
    },
    ValidateName() {
      const regex = /^[A-Za-z\s]+$/;
      if (!regex.test(this.users.name)) {
        this.errors.name = "El nombre solo puede contener letras y espacios";
      } else {
        this.errors.name = "";
      }
    },
    ValidateLastName() {
      const regex = /^[A-Za-z\s]+$/;
      if (!regex.test(this.users.last_name)) {
        this.errors.last_name =
          "El apellido solo puede contener letras y espacios";
      } else {
        this.errors.last_name = "";
      }
    },
    validatePhone() {
      if (this.companies.phone.length != 9 || isNaN(this.companies.phone)) {
        this.errors.phone =
          "El teléfono debe ser un número de máximo 9 dígitos";
      } else {
        this.errors.phone = "";
      }
    },
    validateEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (email == this.companies.email) {
        if (!emailPattern.test(email)) {
          this.errors.email_company =
            "El correo electrónico no tiene un formato válido";
        } else {
          this.errors.email_company = "";
        }
      } else if (email == this.users.email) {
        if (!emailPattern.test(email)) {
          this.errors.email_barber =
            "El correo electrónico no tiene un formato válido";
        } else {
          this.errors.email_barber = "";
        }
      }
    },

    validatePhoneEmployee() {
      if (this.users.phone.length != 9 || isNaN(this.users.phone)) {
        this.errors.phone_barber =
          "El teléfono debe ser un número de máximo 9 dígitos";
      } else {
        this.errors.phone_barber = "";
      }
    },
    onDocumentTypeChange() {
      if (this.users.document_type === "DNI") {
        this.documentMaxLength = 8;
      } else if (this.users.document_type === "RUC") {
        this.documentMaxLength = 11;
      } else if (this.users.document_type === "PASAPORTE") {
        this.documentMaxLength = 15; // Suponiendo que el pasaporte tenga un máximo de 15
      } else if (this.users.document_type === "CARNET EXTRANJERÍA") {
        this.documentMaxLength = 9; // Suponiendo que el carnet de extranjería tenga un máximo de 12
      }
    },
    validateDocument() {
      if (
        this.users.dni.length !== this.documentMaxLength ||
        isNaN(this.users.dni)
      ) {
        this.errors.dni = `El ${this.users.document_type} debe tener ${this.documentMaxLength} dígitos y ser un número válido.`;
      } else {
        this.errors.dni = "";
      }
    },
    validateForm() {
      // this.ValidateName();
      // this.ValidateLastName();
      this.validateRUC();
      this.validatePhone();
      this.validateEmail(this.companies.email);
      if (this.modal.action === "store") {
        this.ValidateName();
        this.ValidateLastName();
        // this.validateDocumentNumber();
        this.validatePhoneEmployee();
        this.validateEmail(this.users.email);
      }

      return (
        this.errors.ruc === "" &&
        this.errors.phone === "" &&
        this.errors.dni === "" &&
        this.errors.phone_barber === "" &&
        this.errors.email_company === "" &&
        this.errors.email_barber === ""
      );
    },
    changeSwitch: function (payload) {
      this.companies.state = payload == true ? 1 : 0;
    },
    /** instancias wsp */
    mtdInstance: function(payload){
      this.modalWsp.modal_form=true;
      this.modalWsp.title="Instancia de wsp";
      this.modalWsp.item = payload;
    },
    mtdCloseModalWsp: function(action){
      this.modalWsp.modal_form=false;
      this.modalWsp.item = {
        id:0,
        instance_name:"",
        instance_id:"",
        conected:"",
        state:""
      }
      if (action == 'create') {
        this.mtd_getdata();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}

.container-img {
  margin: 10px 0 0 0;
  display: flex;
  justify-content: center;
}
</style>
